// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"499":"64f913cb6787aaf7","4079":"4fd8279f97689d6b"}[chunkId] + ".js";
};